import {
  SHOW_SETTING,
  SHOW_MANAGE,
  SHOW_MAP_LAYER,
  SHOW_CHART,
  SHOW_MENU,
  SHOW_MENU_POPUP,
  RESET_LAYER_ALL
} from "./type";

export const changeSetting = (status) => async (dispatch) => {
  dispatch({
    type: SHOW_SETTING,
    payload: status,
  });
};

export const changeManage = (status) => async (dispatch) => {
  dispatch({
    type: SHOW_MANAGE,
    payload: status,
  });
};

export const changeChart = (status) => async (dispatch) => {
  dispatch({
    type: SHOW_CHART,
    payload: status,
  });
};

export const changeMenu = (status) => async (dispatch) => {
  dispatch({
    type: SHOW_MENU,
    payload: status,
  });
};

export const showMapLayer = (status) => async (dispatch) => {
  dispatch({
    type: SHOW_MAP_LAYER,
    payload: status,
  });
};

export const showMenuPopup = (status) => async (dispatch) => {
  dispatch({
    type: SHOW_MENU_POPUP,
    payload: status,
  });
};

export const onResetLayerAll = (status) => async (dispatch) => {
  dispatch({
    type: RESET_LAYER_ALL,
    payload: status,
  });
};
